































































































































































































import {Component, Vue} from "vue-property-decorator";
import {TimeAssistant} from "@/entity/TimeAssistant";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {TimeAssistantDto} from "@/dto/TimeAssistantDto";
import {XmppUtils} from "@/xmpp/XmppUtils";
import {UserDto} from "@/oauth/UserDto";
import {ajax} from "jquery";
import {TimeAssistantAttachment} from "@/entity/TimeAssistantAttachment";
import {TimeAssistantAttachmentDto} from "@/dto/TimeAssistantAttachmentDto";
import {TimeAssistantCollaborator} from "@/entity/TimeAssistantCollaborator";
import {TimeAssistantCollaboratorDto} from "@/dto/TimeAssistantCollaboratorDto";
import {Friend} from "@/entity/Friend";

@Component({
  components: {},
})

export default class AddTimeAssistant extends Vue {
  su = SecurityUtils;
  timeAssistant = new TimeAssistant();
  collaborator = false;
  recentlyFriends: Friend[] = [];
  imageArray: string[] = [];
  text = '';

  //搜索
  get recentlyFriend() {
    const friends = this.recentlyFriends.filter(v => v.name.toLowerCase().indexOf(this.text) > -1);
    return friends;
  }

  //展示
  get recentlyFriends1() {
    const friends: Friend[] = [];
    this.recentlyFriends.forEach(value => {
      if (value.createCollaborator)
        friends.push(value);
    });
    return friends;
  }


  handleButtonSelected() {
    if (this.$refs.selectFiles != null) {
      (this.$refs.selectFiles as any).click()
    }
  }

  closeImg(img: string) {
    for (let i = 0; i < this.imageArray.length; i++) {
      if (this.imageArray[i] === img) {
        this.imageArray.splice(i, 1);
      }
    }
  }

  uploadIt() {
    this.handleButtonSelected();
  }

  handlerUpload(e: any) {
    const files = e.target.files[0] //当input中选择文件时触发一个事件并让data当中的files拿到所选择的文件
    const formData = new FormData();
    formData.append("file", files);
    formData.append("system", 'customer');
    const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
    try {
      ajax({
        type: 'POST',
        url: "https://fileserver.yong-gang.cn/api/uploadFile",
        dataType: 'json',
        data: formData,
        processData: false,   // jQuery不要去处理发送的数据
        contentType: false,  // jQuery不要去设置Content-Type请求头
        success: (data: any) => {
          this.imageArray.push(data.data.filePreviewUrl);
          nf({type: 'positive', message: '上传成功', timeout: 1500});
        },
        timeout: 999999,
        error: () => {
          console.log('出错了');
          nf({type: 'positive', message: '上传失败', timeout: 1500});
        }
      })
    }catch (e) {
      nf({type: 'negative', message: '上传失败:' + e, timeout: 4000});
    }
  }

  async addTimeAssistant() {
    if (!this.timeAssistant.programme.trim()) {
      this.$q.notify({message: '日程内容不能为空', timeout: 1000, color: 'red'});
    } else if (!this.timeAssistant.startDate.trim()) {
      this.$q.notify({message: '日程开始时间不能为空', timeout: 1000, color: 'red'});
    } else if (new Date(this.timeAssistant.startDate) >= new Date(this.timeAssistant.stopDate)) {
      this.$q.notify({message: '日程开始时间必须早于结束时间', timeout: 1000, color: 'red'});
    } else if (new Date(this.timeAssistant.startDate) < new Date()) {
      this.$q.notify({message: '日程开始时间必须晚于当前时间', timeout: 1000, color: 'red'});
    } else {
      const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 5000});
      this.timeAssistant.username = this.su.getLoginUser().username;
      const timeAssistant = await TimeAssistantDto.save(this.timeAssistant);
      const timeAssistantCollaborator = new TimeAssistantCollaborator();
      timeAssistantCollaborator.timeAssistantId = timeAssistant.id as number;
      timeAssistantCollaborator.name = this.su.getLoginUser().name;
      timeAssistantCollaborator.url = this.su.getLoginUser().avatarUrl;
      timeAssistantCollaborator.username = this.su.getLoginUser().username;
      timeAssistantCollaborator.isRespond = true;
      await TimeAssistantCollaboratorDto.save(timeAssistantCollaborator);
      for (const value1 of this.imageArray) {
        const timeAssistantAttachment = new TimeAssistantAttachment();
        timeAssistantAttachment.timeAssistantId = timeAssistant.id as number;
        timeAssistantAttachment.url = value1;
        await TimeAssistantAttachmentDto.save(timeAssistantAttachment);
      }
      for (const value of this.recentlyFriends) {
        if (value.createCollaborator) {
          // const user = await UserDto.findByUsername(value.jid.substring(0, 11))
          // this.timeAssistant.username = user.id as number;
          // this.timeAssistant.createId = this.su.getLoginUser().id as number;
          // this.timeAssistant.timeAssistantId = timeAssistant.id as number;
          // const timeAssistant1 = await TimeAssistantDto.save(this.timeAssistant);

          const timeAssistantCollaborator1 = new TimeAssistantCollaborator();
          timeAssistantCollaborator1.timeAssistantId = timeAssistant.id as number;
          timeAssistantCollaborator1.name = value.name;
          timeAssistantCollaborator1.url = value.avatarUrl;
          timeAssistantCollaborator1.username = value.jid.substring(0, 11);
          await TimeAssistantCollaboratorDto.save(timeAssistantCollaborator1);
          // for (const value1 of this.imageArray) {
          //   const timeAssistantAttachment = new TimeAssistantAttachment();
          //   timeAssistantAttachment.timeAssistantId = timeAssistant1.id as number;
          //   timeAssistantAttachment.url = value1;
          //   await TimeAssistantAttachmentDto.save(timeAssistantAttachment);
          // }
        }
      }
      nf({type: 'positive', message: '完成', timeout: 1500});
      await this.$router.go(-1);

    }
  }

  mounted() {
    XmppUtils.friends.forEach(value => {
      if (value.createCollaborator)
        value.createCollaborator = false;
    });
    this.recentlyFriends = XmppUtils.friends;
  }

}
